import { Input } from 'antd';

const TextArea = Input.TextArea;

const HVTextArea = ({ helpers, meta, ...props }) => {
    return <TextArea {...props} />;
};

export default HVTextArea;
